/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\RouterService\RouterService.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday June 27th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday, 10th October 2023 04:03:42
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

export function InitRequestParams(url: string) {
    let page = 1;
    let orderedby = "";
    let per_page = 20;
    let status: string | undefined = undefined;
    let editable: boolean | undefined = undefined;
    let usertab: number | undefined = undefined;
    let offertab: number | undefined = undefined;
    let tabkey: string | undefined = undefined;

    const mySearchParams = new URL(url).searchParams;
    if (mySearchParams.has("page"))
        page = parseInt(mySearchParams.get('page')!);
    if (mySearchParams.has('orderedby'))
        orderedby = mySearchParams.get('orderedby')!;
    if (mySearchParams.has('per_page'))
        per_page = parseInt(mySearchParams.get('per_page')!);
    if (mySearchParams.has('status'))
        status = mySearchParams.get('status')!;
    if (mySearchParams.has('editable'))
        editable = mySearchParams.get('editable')!.toLowerCase().trim() === "true";
    if (mySearchParams.has('usertab'))
        usertab = parseInt(mySearchParams.get('usertab')!);
    if (mySearchParams.has('offertab'))
        offertab = parseInt(mySearchParams.get('offertab')!);
    if (mySearchParams.has('tabkey'))
        tabkey = mySearchParams.get('tabkey')!;
    return {page, orderedby, per_page, status, editable, usertab, offertab, tabkey};
};

export function ExtractQueryInObj(request: Request) {
    const searchParams = new URL(request.url).searchParams;
    let tmp: any = {};
    for (let entry of searchParams.entries())
        tmp[entry[0]] = entry[1];
    return tmp;
};
